import api from './api';

export const leaveApi = {
  // Get all leaves (filtered by user role)
  getAll: () => api.get('/api/leaves').then(res => res.data),
  
  // Get pending leaves (managers only)
  getPending: () => api.get('/api/leaves/pending').then(res => res.data),
  
  // Get current user's leaves
  getMyLeaves: (year) => {
    const params = year ? { year } : {};
    return api.get('/api/leaves/my-leaves', { params }).then(res => res.data);
  },
  
  // Get leave balance for user
  getBalance: (year) => api.get(`/api/leaves/balance/${year}`).then(res => res.data),
  
  // Get specific leave by ID
  get: (id) => api.get(`/api/leaves/${id}`).then(res => res.data),
  
  // Apply for leave
  create: (data) => api.post('/api/leaves', data).then(res => res.data),
  
  // Approve leave (managers only)
  approve: (id) => api.put(`/api/leaves/${id}/approve`).then(res => res.data),
  
  // Reject leave (managers only)
  reject: (id, rejectionReason) => api.put(`/api/leaves/${id}/reject`, { rejection_reason: rejectionReason }).then(res => res.data)
};

export default leaveApi;

